module.exports = __webpack_public_path__ + "media/images/redesign-images/home-new/ig-images/ig-14-2a750543383c406893dd75642fc51a4f.jpg";